<!--<lib-help-icon style="justify-content: unset" (click)="showHelpForDetails()"/>-->

<mat-tab-group
  #tabGroup
  [selectedIndex]="selectedTabIndex()"
  (selectedIndexChange)="onSelectedIndexChange($event)"
  (resized)="updatePagination()"
  libTabActivated
>
  @if (selectedCart()) {
    <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.ConspicuityDetailComponent">
      <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Auffälligkeiten
          </span>
      </ng-template>

      <ng-template matTabContent>
        <kpi4me-conspicuity-detail
          (clientReplaced)="onClientReplaced($event)"
        />
      </ng-template>
    </mat-tab>

    <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.ClientDetailComponent">
      <ng-template mat-tab-label class="mat-tab-label">
        @if (calculusStore.hnrConfig() === false) {
          <span>
            Patient
          </span>
        } @else {
          <span>
            Teilnehmer
          </span>
        }
      </ng-template>


      <ng-template matTabContent>
        <kpi4me-client-detail [showImports]="showImportedValues()"/>
      </ng-template>
    </mat-tab>

    @if (calculusStore.hnrConfig() === false) {
      <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.TransportDetailComponent">
        <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Transport
          </span>
        </ng-template>

        <ng-template matTabContent>
          @if (cartFilter()) {
            <kpi4me-transport-detail
              [showImports]="showImportedValues()"
            ></kpi4me-transport-detail>
          }
        </ng-template>
      </mat-tab>

      <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.CrewDetailComponent">
        <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Verordnung
          </span>
        </ng-template>

        <ng-template matTabContent>
          <kpi4me-crew-detail [showImports]="showImportedValues()"/>
        </ng-template>
      </mat-tab>

      <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.CartAdditionalDetailComponent">
        <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Infos
          </span>
        </ng-template>

        <ng-template matTabContent>
          <kpi4me-cart-additional-detail/>
        </ng-template>
      </mat-tab>
    }

    @if (calculusStore.hnrConfig() === true) {
      <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.ShippingAndPaymentComponent">
        <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Versand & Zahlung
          </span>
        </ng-template>

        <ng-template matTabContent>
          <app-shipping-and-payment [showImports]="showImportedValues()"/>
        </ng-template>
      </mat-tab>
    }

    <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.InvoiceDetailComponent">
      <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Rechnung
          </span>
      </ng-template>

      <ng-template matTabContent>
        <kpi4me-invoice-detail/>
      </ng-template>
    </mat-tab>

    <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.DocumentDetailComponent">
      <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Dokumente
          </span>
      </ng-template>

      <ng-template matTabContent>
        <kpi4me-document-detail (detailDocumentToggleTriggered)="detailDocumentToggleTriggered.emit($event)"/>
      </ng-template>
    </mat-tab>

    <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.InternalNoteDetailComponent">
      <ng-template mat-tab-label class="mat-tab-label">
        @if (internalNote() != '') {
          <mat-icon class="red-icon" [svgIcon]="EsvgFiles.warning"/>
        }

        <span>
          Interne Notizen
        </span>
      </ng-template>

      <ng-template matTabContent>
        <kpi4me-internal-note-detail/>
      </ng-template>
    </mat-tab>

    @if (calculusStore.hnrConfig() === false) {
      <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.PermanentOrdinanceComponent">
        <ng-template mat-tab-label class="mat-tab-label">
          <span>
            Dauerverordnung
          </span>
        </ng-template>

        <ng-template matTabContent>
          <kpi4me-permanent-ordinance/>
        </ng-template>
      </mat-tab>
    }

    <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.ChangeLogComponent">
      <ng-template mat-tab-label class="mat-tab-label">
        <span>
          Changelog
        </span>
      </ng-template>

      <ng-template matTabContent>
        <kpi4me-change-log/>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
